const INACTIVE_COLOR = "var(--color-provenance-inactive)";

const TONE_PRESENTATIONS = Object.freeze({
    success: Object.freeze({
        badgeClass: "badge-success",
        color: "var(--color-provenance-success)",
    }),
    warning: Object.freeze({
        badgeClass: "badge-warning",
        color: "var(--color-provenance-warning)",
    }),
    info: Object.freeze({
        badgeClass: "badge-info",
        color: "var(--color-provenance-info)",
    }),
    secondary: Object.freeze({
        badgeClass: "badge-secondary",
        color: "var(--color-provenance-secondary)",
    }),
    accent: Object.freeze({
        badgeClass: "badge-accent",
        color: "var(--color-provenance-accent)",
    }),
    neutral: Object.freeze({
        badgeClass: "badge-neutral",
        color: "var(--color-provenance-neutral)",
    }),
});

const TONE_FAMILIES = Object.freeze({
    community: "success",
    "community-presence": "success",
    database: "info",
    derived: "info",
    imported: "secondary",
    manual: "success",
    mixed: "neutral",
    neutral: "neutral",
    overlay: "secondary",
    "rate-known": "success",
    "rate-uncertain": "warning",
    ranking: "success",
    "ranking-full": "success",
    "ranking-partial": "warning",
});

/**
 * Resolves the one semantic palette shared by provenance source labels and
 * compact indicator rails.
 */
export function provenanceToneStyle(tone, { active = true } = {}) {
    const family = TONE_FAMILIES[String(tone ?? "").trim()] ?? "neutral";
    const presentation = TONE_PRESENTATIONS[family];
    return Object.freeze({
        badgeClass: presentation.badgeClass,
        color: active ? presentation.color : INACTIVE_COLOR,
    });
}

export function provenanceSourceBadgeClass(tone) {
    return provenanceToneStyle(tone).badgeClass;
}

export function provenanceIndicatorColorForTone(tone, { active = true } = {}) {
    return provenanceToneStyle(tone, { active }).color;
}
